import util from 'util';
import { CONSTANT } from '@const';
import { VerifyEmailCheckPayload, VerifyEmailPayload, VerifyEmailResponse } from '@types';

import { ApiParams, ApiService } from '../api/ApiService';

export class EmailVerificationService extends ApiService {
	static async VerifyEmail(emailAddress: string): Promise<VerifyEmailResponse> {
		const payload: VerifyEmailPayload = { emailAddress: emailAddress };
		const params: ApiParams = {
			method: 'POST',
			url: util.format(CONSTANT.EMAIL_VERIFICATION_VERIFY_API_URL),
			data: payload,
		};
		return await this.executeApiRequest(params);
	}

	static async VerifyCheckEmail(emailAddress: string, code: string): Promise<VerifyEmailResponse> {
		const payload: VerifyEmailCheckPayload = {
			emailAddress: emailAddress,
			code: code,
		};
		const params: ApiParams = {
			method: 'POST',
			url: util.format(CONSTANT.EMAIL_VERIFICATION_CHECK_API_URL),
			data: payload,
		};

		return await this.executeApiRequest(params);
	}
}
